export default {
  '01': ['понедельник', 'пн'],
  '02': ['вторник', 'вт'],
  '03': ['среда', 'ср'],
  '04': ['четверг', 'чт'],
  '05': ['пятница', 'пт'],
  '06': ['суббота', 'сб'],
  '07': ['воскресенье', 'вс'],
};
